import classnames from 'classnames';
import { Form } from 'components/bootstrap';
import { format, parse } from 'date-fns';
import PropTypes from 'prop-types';
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from 'styled-components';
import { colors } from 'styles/shared';
import './DatePicker.css';


const FormGroup = styled.div`
  margin-bottom: 0;
  height: 9rem;
`;

const DatePickerOverride = styled(DatePicker)`
  width: 23.5rem;
  height: 5rem;
  background: ${colors.blue_lighter};
  border-radius: 1.5rem;
  margin-right: 1rem;
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_darker};
  padding: 1.6rem 2rem;
  border-style: none;
  display: inline-block;
  border: ${props => (props.error ? '0.1rem solid red' : 'none')};
  margin-bottom: 0.8rem;

  ::placeholder {
    opacity: 0.3;
  }

  &:focus {
    background: ${colors.blue_lighter};
  }
`;

const InputError = styled.div`
  font-size: 1.4rem;
  line-height: 1.9rem;
  letter-spacing: 0.03rem;
  color: red;
`;

DatePickerInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool
};

DatePickerInput.defaultProps = {
  className: ''
};

function DatePickerInput({name, label = '', index, onChange, placeholder, value, error, type, disabled, className}) {
  let wrapperClass = classnames({
    'form-group': true,
    'has-error': error && error.length > 0,
    [className]: className ? true : false
  });

  let inputOnChange = event => {
    onChange(index,name,format(event, 'yyyy-MM-dd'));
  };

  let dateValue = value ? value : format(new Date(), 'yyyy-MM-dd');


  return (
    <FormGroup className={wrapperClass}>
      {label && <Form.Label htmlFor={name}>{label}</Form.Label>}
      <DatePickerOverride
        selected={parse(dateValue,'yyyy-MM-dd', new Date())}
        onChange={inputOnChange}
        name={name}
        className="form-control"
        disabled={disabled}
        error={error}
      />
      {error && <InputError>{error}</InputError>}
    </FormGroup>
  );
}

export default DatePickerInput;
